import INFTCollections from '../../models/INFTCollections'
import TinyDragonLogo from '../../../../assets/nft-logo/TinyDragons.png'
import GeneralCard from '../../nftFormats/Generals/Card/GeneralCard'
import GeneralActivityDetail from '../../nftFormats/Generals/Activity/GeneralActivityDetail'
import TinyDragonDetail from '../../nftFormats/TinyDragon/Detail/TinyDragonDetail'

export const TinyDragonData: INFTCollections[] = [
  {
    id: 'TinyDragon',
    tokenAddress: '0x2144A0eB052DD991Ec8f34b6a46D2d2Eb765C026',
    name: 'Tiny Dragon',
    cardFormat: GeneralCard,
    detailFormat: TinyDragonDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    creatorAddress: '0x6Cb689495703f10b94d023b410a400b1575Cc65F',
    logo: TinyDragonLogo,
    website: 'https://tinydragon.games',
    twitter: 'DRGNCRYPTOGAMIN',
    discord: 'https://discord.gg/EjtYmpSPVJ'
  }
]

export const TinyDragonCategoryData = {
  [TinyDragonData[0].tokenAddress.toLowerCase()]: TinyDragonData[0].category
}
